"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = void 0;
var react_1 = __importDefault(require("react"));
var useFormControl_1 = require("../../hooks/useFormControl");
var styles_1 = require("../../styles");
var FormControl_1 = require("../FormControl");
var TextInputBase_1 = require("../TextField/TextInputBase");
function TextArea(props) {
    var style = props.style, label = props.label, resize = props.resize, rest = __rest(props, ["style", "label", "resize"]);
    var error = props.error, restFormControlProps = __rest(props, ["error"]);
    var valueLength = props.value && typeof props.value === 'string' && props.value.length;
    var defaultValueLength = props.defaultValue && typeof props.defaultValue === 'string' && props.defaultValue.length;
    var currentLength = valueLength || defaultValueLength || 0;
    var getFormControlProps = useFormControl_1.useFormControl(restFormControlProps).getFormControlProps;
    var getInputProps = useFormControl_1.useFormControl(props).getInputProps;
    var inputProps = getInputProps();
    var invalid = inputProps['aria-invalid'];
    var errorId = inputProps['aria-errormessage'];
    var _a = styles_1.useStyles(createStyles, { invalid: invalid }), classes = _a.classes, css = _a.css;
    var className = css(classes.input, invalid && classes.invalid, style, { resize: resize });
    return (react_1.default.createElement(FormControl_1.FormControl, __assign({}, getFormControlProps()),
        react_1.default.createElement("textarea", __assign({ className: className }, inputProps, rest)),
        react_1.default.createElement("div", { className: classes.footer },
            error && (react_1.default.createElement(FormControl_1.FormError, { id: errorId, role: 'alert' }, error)),
            props.maxLength && (react_1.default.createElement("div", { className: classes.counter },
                currentLength,
                "/",
                props.maxLength,
                " caracteres")))));
}
exports.TextArea = TextArea;
var createStyles = function (theme, _a) {
    var invalid = _a.invalid;
    return (__assign(__assign({}, TextInputBase_1.createStyles(theme)), { footer: {
            display: 'flex',
        }, counter: {
            marginLeft: 'auto',
            color: invalid && theme.pallete.status.danger.main,
        } }));
};
//# sourceMappingURL=TextArea.js.map